import { COMPANY_INFO_LABEL_DEFAULTS, type Branding } from '@l2u/shared/schemas';

export type CompanyInfoLabelKey = keyof typeof COMPANY_INFO_LABEL_DEFAULTS;

export function companyInfoLabel(
  branding: Partial<Branding> | undefined,
  key: CompanyInfoLabelKey,
): string {
  const override = branding?.companyInfoLabels?.[key];
  if (typeof override === 'string' && override.trim().length > 0) return override;
  return COMPANY_INFO_LABEL_DEFAULTS[key];
}

export function contractorTypeOptions(branding: Partial<Branding> | undefined): string[] {
  return branding?.contractorTypeOptions ?? [];
}
